export default "__VITE_ASSET__DtFEbJL7__"